/**
 * Internal dependencies
 */
// import '../template-parts/header/header';
// import '../template-parts/footer/footer';
// import '../template-parts/newsletter-modal/newsletter-modal';
import './modules/_index.js';

import './view.css';
